(function () {
  'use strict';

  angular.module('lif.controllers').controller('leftNavigationController', leftNavigationController);
  leftNavigationController.$inject = ['$scope', '$rootScope', '$timeout', 'bootstrappedNavigationModel'];

  function leftNavigationController($scope, $rootScope, $timeout, bootstrappedNavigationModel) {
    var vm = this;
    vm.topsLinks = bootstrappedNavigationModel.topLinks;
    vm.redWeb = bootstrappedNavigationModel.redWeb;
    vm.logOut = bootstrappedNavigationModel.logOut;
    vm.userSettings = bootstrappedNavigationModel.userSettings;

    $scope.$onInit = function () {
      window.resizeLeftNavbar();
    };

    vm.adjustLeftNavHeight = function () {
      $timeout(function () {
        window.resizeLeftNavbar();
      }, 200);
    };

    vm.loadingSpinner = function () {
      $('#loading').show();
    };

    $rootScope.siteLayout = bootstrappedNavigationModel.siteLayout;
  }

  ;
})();